export default __webpack_public_path__ + "static/media/child_care.02e3c86e.svg";